const headers = {
  x_centro_session_id: "x-centro-session-id",
  x_centro_signature: "x-centro-signature",
  x_centro_timestamp: "x-centro-timestamp"
}

exports.request = (path, method = "GET", body, authorization, contentType = "application/json") => {
  let options = {
    method: method,
    headers: {}
  };
  if (method.toLowerCase() !== "get") {
    options.method = method;
    if (body !== undefined) {
      options.body = body;
      options.headers["Content-Type"] = contentType;
    }
    if (typeof(authorization) === "string") {
      options.headers["X-Centro-AuthToken"] = authorization;
    }
    if (window.localStorage) {
      const sessionId = window.localStorage.getItem("sessionId");
      const signature = window.localStorage.getItem("signature");
      const timestamp = window.localStorage.getItem("timestamp");
      if (sessionId) {
        options.headers[headers.x_centro_session_id] = sessionId;
      }
      if (signature) {
        options.headers[headers.x_centro_signature] = signature;
      }
      if (timestamp) {
        options.headers[headers.x_centro_timestamp] = timestamp;
      }
    }
  }
  const req = new Request(path, options);
  return new Promise((resolve, reject) => {
    window.fetch(req).then((resp) => {
      if (resp.status >= 200 && resp.status < 300) {
        if (resp.headers && typeof(resp.headers.get(headers.x_centro_session_id)) === "string") {
          window.localStorage.setItem("sessionId", resp.headers.get(headers.x_centro_session_id));
        }
        if (resp.headers && typeof(resp.headers.get(headers.x_centro_signature)) === "string") {
          window.localStorage.setItem("signature", resp.headers.get(headers.x_centro_signature));
        }
        if (resp.headers && typeof(resp.headers.get(headers.x_centro_timestamp)) === "string") {
          window.localStorage.setItem("timestamp", resp.headers.get(headers.x_centro_timestamp));
        }
        if (resp.status !== 204 && resp.headers && resp.headers.get("Content-Type") && resp.headers.get("Content-Type").indexOf("json") > -1) {
          resolve(resp.json());
        }
        else {
          // Non-json result type (i.e. images etc)
          resolve(resp);
        }
      }
      else {
        reject(resp);
      }
    }).catch(e => reject(e));
  });
};

exports.createQueryString = (jsMap = {}) => {
  let ret = [];
  for (let name in jsMap) {
    if (jsMap.hasOwnProperty(name) && jsMap[name] !== undefined) {
      ret.push([encodeURIComponent(name), encodeURIComponent(jsMap[name])].join("="));
    }
  }
  return ret.join("&");
};